import React from "react";
import { Link, type LinkProps } from "react-router-dom";

export interface QuickActionLinkProps
  extends React.PropsWithChildren<{
      to: string;
      className?: string;
    }>,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "className"> {}

/**
 * Quick Action paths that should use client-side navigation (<Link>).
 * Everything else falls back to a plain <a>.
 */
const LINK_PATHS = new Set<string>(["/cards/subscriptions", "/direct_deposit"]);

const QuickActionLink = React.forwardRef<
  HTMLAnchorElement,
  QuickActionLinkProps
>(({ to, className, children, ...rest }, ref) => {
  if (LINK_PATHS.has(to)) {
    const linkProps = rest as unknown as Omit<LinkProps, "to">;

    return (
      <Link
        ref={ref as React.Ref<HTMLAnchorElement>}
        to={to}
        className={className}
        {...linkProps}
      >
        {children}
      </Link>
    );
  }

  return (
    <a ref={ref} href={to} className={className} {...rest}>
      {children}
    </a>
  );
});

export default QuickActionLink;
